export class PositionImporter {
    constructor(data) {
        this.data = data;
        this.currPosition = 0;
    }
}
